<template>
    <div>

        <nav>

            <v-app-bar color="indigo" dark fixed app>
                <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title class="text-uppercase grey--text">
                    <span class="font-weight-light">ISSUES HISTORY</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>


                <v-btn v-if="view == 'header'" text color="grey"
                    @click.prevent="refresh()">
                    <v-icon right>refresh</v-icon>
                </v-btn>

                <div >

                    <download-excel
                        class="btn btn-default"
                        :data="issues"
                        worksheet="My Worksheet"
                        :name="fileName"
                    >
                    <img :src="getFileIcon(doc)" 
                                class="file-icon" />     
                    </download-excel>

                </div>

                <v-btn text color="grey"
                    @click.prevent="signOut">
                    <span></span>
                    <v-icon right>exit_to_app</v-icon>
                </v-btn>

            </v-app-bar> 

            <NavDraw :drawer="drawer" ></NavDraw>

        </nav>

        <v-container>
            
            <div v-if="view=='header'">
            
                <v-layout column child-flex>


                    <v-flex >

                        <v-data-table
                            :headers="headers"
                            :items="issues"
                            :items-per-page="10"
                            class="elevation-1"
                            mobile-breakpoint="0"
                            :search="search"
                            :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-arrow-collapse-left',
                            lastIcon: 'mdi-arrow-collapse-right',
                            prevIcon: 'mdi-minus',
                            nextIcon: 'mdi-plus'
                            }"                        
                        >

                            <template v-slot:[`item.issueID`]="{ item }">
                                <v-chip
                                    color="warning"
                                    dark
                                    style="cursor:pointer;"
                                    @click="viewIssueDetails(item)"
                                >
                                    {{ item.issueID }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.issue`]="{ item }">
                                <div class="truncate"> {{ item.issue }} </div>
                            </template>

                            <template v-slot:[`item.description`]="{ item }">
                                <div class="truncate"> {{ item.description }} </div>
                            </template>

                            <template v-slot:[`item.solutionDesc`]="{ item }">
                                <div class="truncate"> {{ item.solutionDesc }} </div>
                            </template>

                            <template v-slot:[`item.raisedBy`]="{ item }">
                                <div class="truncate"> {{ item.raisedBy }} </div>
                            </template>

                            <template v-slot:[`item.assignedTo`]="{ item }">
                                <div class="truncate"> {{ item.assignedTo }} </div>
                            </template>

                            <template v-slot:[`item.diagnostic`]="{ item }">
                                <div class="truncate"> {{ item.diagnostic }} </div>
                            </template>

                            <template v-slot:top>
                                <v-text-field
                                v-model="search"
                                label="Search"
                                class="mx-4"
                                ></v-text-field>
                            </template>

                        </v-data-table>

                    </v-flex>
                </v-layout>
        
            </div>
            <div v-else-if="view=='detail'">
                <v-layout column>
                    <v-flex>
                        <IssuesHistoryDet :issue="activeIssue" @close="view = 'header'"></IssuesHistoryDet>
                    </v-flex>
                </v-layout>
            </div>

        </v-container>    

        <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            color="purple"
            size="200"
        ></v-progress-circular>
        </v-overlay>

    </div>
</template>
<script>

import { mapState,mapActions } from 'vuex'
import NavDraw from '@/components/NavDraw'

const fb = require('../../firebaseConfig.js')

import IssuesHistoryDet from './IssuesHistoryDet.vue'

export default {

    components:{NavDraw,IssuesHistoryDet},
    data(){
        return {
            drawer:false,
            view:"header",
            searchString:"",
            issues:[],
            //issues:[],
            activeIssue:null,
            headers:[
                {text:'Issue ID',value:'issueID'},
                {text:'Issue',value:'issue'},
                {text:'Issue Type',value:'issueType'},
                {text:'Issue Subtype',value:'issueSubtype'},
                {text:'Desc',value:'description'},
                {text:'Dept',value:'department'},
                {text:'Location',value:'location'},
                {text:'Section',value:'section'},
                {text:'Raised by',value:'raisedBy'},
                {text:'Status',value:'status'},
                {text:'Brand',value:'brand'},
                {text:'Prod. Order No.',value:'prodOrderNo'},
                {text:'Color',value:'color'},
                {text:'Prod. Line',value:'productLine'},
                {text:'Cut Qty.',value:'cutQty'},
                {text:'Affected Qty.',value:'affectedQty'},
                {text:'Assigned To',value:'assignedTo'},
                {text:'Assigned By',value:'assignedBy'},
                {text:'Diagnostic',value:'diagnostic'},
                {text:'Solution',value:'solution'},
                {text:'Soln Type',value:'solutionType'},
                {text:'Soln Method',value:'solutionMethod'},
                {text:'Soln Desc',value:'solutionDesc'},
                {text:'Assigned Date',value:'assignedDate'},
                {text:'Comm Date',value:'commitmentDate'},
                {text:'Close Date',value:'closeDate'},
                {text:'Creation Date',value:'creationDate'},
            ],
            icons:{
                excel: require('../../assets/excel-icon.png'),
                word: require('../../assets/word-icon.png'),
                pdf: require('../../assets/pdf-icon.png'),
                mindmap: require('../../assets/mindmap-icon.png')
            },
            overlay:false,
            search:''
        }
    },
    computed:{
        ...mapState(['currentUser'])
    },
    methods:{
        ...mapActions(['setCurrentUser']),
        refresh(){
            this.setIssues()
        },
        setIssues(){
            
            this.overlay = true
            let issues = [];
            fb.issuesCollection.where("hdType","==",this.currentUser.hdType).get()
            .then(colIssues=>{
                //console.log("docs",docs)
                colIssues.forEach(issue=>{
				
                    //console.log("issue",issue.data());
                   // if ( issue.data().status != 'Verified Close'){ 

                        const data = {
                            'id':issue.id,
                            'issueID': issue.data().issueID,
                            'issue':issue.data().issue,
                            'issueType':issue.data().issueType,
                            'issueSubtype':issue.data().issueSubtype,
                            'description':issue.data().description,
                            'department':issue.data().department,
                            'location':issue.data().location,
                            'raisedBy':issue.data().raisedBy,
                            'status':issue.data().status,
                            'brand':issue.data().brand,
                            'assignedTo':issue.data().assignedTo,
                            'assignedToID':issue.data().assignedToID,
                            //'assignedDate':issue.data().assignedDate.toDate(),
                            'assignedBy':issue.data().asssignedBy,
                            //'commitmentDate':issue.data().commitmentDate.toDate(),
                            'solution':issue.data().solution,
                            'solutionType':issue.data().solutionType,
                            'solutionDesc':issue.data().solutionDesc,
                            'creationDate': this.formatDate( issue.data().creationDate.toDate() ),
							'dateID':issue.data().dateID,
                            'prodOrderNo':issue.data().prodOrderNo,
                            'color':issue.data().color,
                            'productLine':issue.data().productLine,
                            'cutQty':issue.data().cutQty,
                            'affectedQty':issue.data().affectedQty

                        }
                        data.assignedDate = issue.data().assignedDate ? this.formatDate( issue.data().assignedDate.toDate() ) : new Date('1/1/0001')
                        data.commitmentDate = issue.data().commitmentDate ? this.formatDate(  issue.data().commitmentDate.toDate() ) : new Date('1/1/0001')
                        data.closeDate = issue.data().closeDate ? this.formatDate( issue.data().closeDate.toDate() ) : new Date('1/1/0001')
                        data.location = issue.data().location ?  issue.data().location : ''
                        data.section = issue.data().section ? issue.data().section : ''
                        data.diagnostic = issue.data().diagnostic ? issue.data().diagnostic : ''
                        data.solutionMethod = issue.data().solutionMethod ? issue.data().solutionMethod : ''

                        issues.push(data);

                    //}

                });
                issues.sort((a,b)=>(a.issueID > b.issueID) ? 1 : -1);

                this.$store.state.issues = [...issues]
                this.issues = [...issues]

                this.overlay = false

            })//then

        },
        viewIssueDetails(issue){
            console.log(issue)
            this.view = "detail";
            this.activeIssue = issue;

        },
        formatDate (date) {
            if (!date) return null
            //console.log("foramt date",date)
            //const [year, month, day] = date.split('/')
            date = new Date(date).toISOString().substr(0, 10)
            const [year,month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },
        getFileIcon(){
            return this.icons.excel;
        },
        signOut(){

            //this.issuesBuffer.issues = []

            //clean up state-level data
            this.$store.state.assignees = []
            this.$store.state.departments = []
            this.$store.state.sections = []
            this.$store.state.issueMaster = []
            this.$store.state.issueTypes = []
            this.$store.state.issueSubtypes = []
            this.$store.state.locations = []
            this.$store.state.sections = []
            this.$store.state.assignees = []
            this.$store.state.solutionTypes = []
            this.$store.state.solutions = []
            this.$store.state.solutionMethods = []
            this.$store.state.diagnostics = []
            this.$store.state.diagnosticTypes = []
            this.$store.state.issueStatuses = []
            this.$store.state.problemSources = []
            this.$store.state.accountablePersons = []

            let self = this;
            fb.auth.signOut().then(function() {
                self.$router.push({name:'Login'})
            }).catch(function(error) {
                // An error happened.
                console.log(error.message)
            });

        },
        async checkDropdownLists(){

            if (!this.currentUser){
                return
            }

            //console.log("this.currentUser.hdType",this.$store.state.currentUser.hdType)
            if (this.$store.state.brands.length == 0){
                let brands = []
                let b = await fb.brandsCollection.get()
                //console.log('b',b)
                for(const doc of b.docs){
                    brands.push(doc.data().brand);
                }
                this.$store.state.brands = [...brands]
                //console.log("this.brands",this.$store.state.brands)
            }

            if (this.$store.state.assignees.length == 0){
                let assignees = []
                let b = await fb.assigneesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    assignees.push({
                        assignee:doc.data().assignee,
                        assigneeID:doc.data().assigneeID,
                        department:doc.data().department,
						hdType:doc.data().hdType
                    });
                }
                this.$store.state.assignees = [...assignees]
                //console.log("this.$store.state.assignees",this.$store.state.assignees)
            }

            if (this.$store.state.departments.length == 0){
                let departments = []
                let b = await fb.departmentsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    departments.push({
                        id:doc.id,
                        department:doc.data().department,
                        hdType:doc.data().hdType
                    });
                }
                this.$store.state.departments = [...departments]
                //console.log("this.$store.state.departments",this.$store.state.departments)
            }

            if (this.$store.state.issueMaster.length == 0){
                let issueMaster = []
                let b = await fb.issueMasterCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    const  issue = {
                        id:doc.id,
                        issue:doc.data().issue,
                        issueType:doc.data().issueType,
                        issueSubtype:doc.data().issueSubtype,
                        idx: doc.data().idx
                    }
                    issueMaster.push(issue);
                }
                this.$store.state.issueMaster = [...issueMaster]
                //console.log("this.brands",this.$store.state.brands)
            }

            if (this.$store.state.issueTypes.length == 0){
                let issueTypes = []
                let b = await fb.issueTypesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    issueTypes.push({
                        id:doc.id,
                        issueType:doc.data().issueType
                    });
                }
                this.$store.state.issueTypes = [...issueTypes]
                //console.log("this.issueTypes",this.$store.state.issueTypes)
            }

            if (this.$store.state.issueSubtypes.length == 0){
                let issueSubtypes = []
                let b = await fb.issueSubtypesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    issueSubtypes.push({
                        id:doc.id,
                        subType:doc.data().subType
                    });
                }
                this.$store.state.issueSubtypes = [...issueSubtypes]
                //console.log("this.issueTypes",this.$store.state.issueTypes)
            }

            if (this.$store.state.locations.length == 0){
                let locations = []
                let b = await fb.locationsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    locations.push({
                        id:doc.id,
                        location:doc.data().location,
                        hdType:doc.data().hdType
                    });
                }
                this.$store.state.locations = [...locations]
                //console.log("this.locations",this.$store.state.locations)
            }

            if (this.$store.state.sections.length == 0){
                let sections = []
                let b = await fb.sectionsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
					sections.push({
                        id:doc.id,
                        section:doc.data().section,
                        hdType:doc.data().hdType
                    });
                }
				sections.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.sections = [...sections]
                //console.log("this.sections",this.$store.state.sections)
            }

            if (this.$store.state.assignees.length == 0){
                let assignees = []
                let b = await fb.assigneesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    assignees.push({
                        assignee:doc.data().assignee,
                        assigneeID:doc.data().assigneeID,
                        department:doc.data().department
                    });
                }
                this.$store.state.assignees = [...assignees]
                //console.log("this.assignees",this.$store.state.assignees)
            }

           if (this.$store.state.solutionTypes.length == 0){
                let solutionTypes = []
                let b = await fb.solutionTypesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    solutionTypes.push({
                        id:doc.id,
                        solutionType:doc.data().solutionType,
                        hdType:doc.data().hdType
                    });
                }
				solutionTypes.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.solutionTypes = [...solutionTypes]
                //console.log("this.solutionTypes",this.$store.state.solutionTypes)
            }

            if (this.$store.state.solutions.length == 0){
                let solutions = []
                let b = await fb.solutionsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    solutions.push({
                        id:doc.id,
                        solution:doc.data().solution,
                        solutionType:doc.data().solutionType,
                        hdType:doc.data().hdType,
                        idx: doc.data().idx
                    });
                }
				solutions.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.solutions = [...solutions]
                //console.log("this.solutions",this.$store.state.solutions)
            }

            if (this.$store.state.solutionMethods.length == 0){
                let solutionMethods = []
                let b = await fb.solutionMethodsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    solutionMethods.push({
                        id:doc.id,
                        method:doc.data().method,
                        hdType:doc.data().hdType
                    });

                }
				solutionMethods.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.solutionMethods = [...solutionMethods]
                //console.log("this.solutionMethods",this.$store.state.solutionMethods)
            }

           if (this.$store.state.diagnostics.length == 0){
                let diagnostics = []
                let b = await fb.diagnosticsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    diagnostics.push({
                        id:doc.id,
                        diagnostic:doc.data().diagnostic,
						diagnosticType:doc.data().diagnosticType,
                        hdType:doc.data().hdType
                    });
                }
				diagnostics.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.diagnostics = [...diagnostics]
                //console.log("this.diagnostics",this.$store.state.diagnostics)
            }

            if (this.$store.state.accountablePersons.length == 0){
                let accountablePersons = []
                let b = await fb.accountablePersonsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
					accountablePersons.push({
                        id:doc.id,
                        accountablePerson:doc.data().accountablePerson,
                        hdType:doc.data().hdType
                    });
                }
				accountablePersons.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.accountablePersons = [...accountablePersons]
                //console.log("this.accountablePersons",this.$store.state.accountablePersons)
            }

            if (this.$store.state.problemSources.length == 0){
                let problemSources = []
                let b = await fb.problemSourcesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
					problemSources.push({
                        id:doc.id,
                        problemSource:doc.data().problemSource,
                        hdType:doc.data().hdType
                    });
                }
				problemSources.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.problemSources = [...problemSources]
                //console.log("this.problemSources",this.$store.state.problemSources)
            }

            if (this.$store.state.issueStatuses.length == 0){
                let issueStatuses = []
                let b = await fb.issueStatusesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
					issueStatuses.push({
                        id:doc.id,
                        issueStatus:doc.data().issueStatus,
                        hdType:doc.data().hdType
                    });
                }
				issueStatuses.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.issueStatuses = [...issueStatuses]
                //console.log("this.issueStatuss",this.$store.state.issueStatuss)
            }


        },


    },
    mounted(){

    },
    created(){

        console.log("IssuesHistory created!")

        if ( !this.$store.state.currentUser || this.$store.state.currentUser.userID == ''){

            let currentUser = JSON.parse(localStorage.getItem('currentUser'))

            if (currentUser){
                this.setCurrentUser(currentUser)
            }else{
                this.$router.push('/')
            }
            
        }

        console.log("this.$store.state.currentUser",this.$store.state.currentUser)



        this.setIssues()
        this.checkDropdownLists()



    }



}
</script>
<style scoped>

.truncate {
  width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.layout {
  display: inline-block;
  width: 100%;
}
.file-icon{
    margin-top:7px;
    width:20px;
    height: 20px;
    max-width: 20px;
    max-height: 20px;
    cursor: pointer;
}
</style>